import React, { Component } from 'react';
import ApolloClient, { createNetworkInterface } from 'apollo-client';
import { ApolloProvider } from 'react-apollo';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import styles from './App.css';
import Routes from '../Routes';

class App extends Component {
    constructor(...args) {
        super(...args);

        const networkInterface = createNetworkInterface(process.env.REACT_APP_API);

        networkInterface.use([{
            applyMiddleware(req, next) {
                if (!req.options.headers) {
                    req.options.headers = {};  // Create the header object if needed.
                }
                // get the authentication token from local storage if it exists
                const token = localStorage.getItem('token') || null;
                if (token) {
                    req.options.headers.Authorization = `Bearer ${token}`;
                }
                next();
            }
        }]);

        this.client = new ApolloClient({
            networkInterface,
            dataIdFromObject: r => r.id
        });

        this.store = createStore(
            combineReducers({
                // todos: todoReducer,
                // users: userReducer,
                apollo: this.client.reducer()
            }),
            applyMiddleware(this.client.middleware()),
            // If you are using the devToolsExtension, you can add it here also
            window.devToolsExtension ? window.devToolsExtension() : f => f,
        );

    }
    
    render() {
        if (! this.store) {
          return null;
        }
        return (
            <ApolloProvider store={this.store} client={this.client}>
                <div className={styles.app}>
                    <Routes />
                </div>
            </ApolloProvider>
        );
    }
}
export default App;



/** WEBPACK FOOTER **
 ** ./src/App/index.js
 **/